import { css, Rule } from 'glamor'
import * as React from 'react'
import * as PropTypes from 'prop-types'
import * as ReactMarkdown from 'react-markdown'
import breaks from 'remark-breaks'

import defaultRenderers from './renderers'

interface IMarkdownProps {
  source: string
  renderers?: { [nodeType: string]: React.ReactType }
  style?: Rule
  className?: string
  escapeHtml?: boolean
  transformLinkUri?: (uri: string, children?: React.ReactNode, title?: string | undefined) => string
}

export function Markdown({ renderers, style, source, escapeHtml, className, transformLinkUri }: IMarkdownProps) {
  return (
    <ReactMarkdown
      {...css(style)}
      className={className}
      escapeHtml={escapeHtml}
      plugins={[breaks]}
      renderers={{ ...defaultRenderers, ...renderers }}
      source={source}
      transformLinkUri={transformLinkUri}
    />
  )
}

Markdown.propTypes = {
  renderers: PropTypes.object,
  style: PropTypes.object,
  className: PropTypes.string,
  source: PropTypes.string,
  escapeHtml: PropTypes.bool,
  transformLinkUri: PropTypes.func,
}

Markdown.defaultProps = {
  renderers: {},
  escapeHtml: true,
}
